export default function createCitationModalDialogStyle() {
  return {
    '&.webchat__citation-modal-dialog': {
      '& .webchat__citation-modal-dialog__body': {
        lineHeight: '20px'
      }
    }
  };
}
